import { configureStore } from '@reduxjs/toolkit';
import counterSlice from './slices/counterSlice';
import websocketSlice from './slices/websocketSlice';
import authSlice from './slices/authSlice';
import cartSlice from './slices/cartSlice';

export const store = configureStore({
  reducer: {
    counter: counterSlice,
    websocket: websocketSlice,
    auth: authSlice,
    cart: cartSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
});

export default store;